var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb"},[_c('RouterLink',{attrs:{"to":{name: 'catalogue.category', params: {slug: _vm.slug}}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }